import React, { useEffect } from 'react';
import Routes from './Routes';
import { useConfig } from '../config/ConfigContext';

const App = () => {
  const appConfig = useConfig();

  const addPageSenseScript = () => {
    const scriptTag = document.createElement('script');
    scriptTag.src = `https://cdn.pagesense.io/js/lendingusa/${appConfig.pageSenseId}.js`;
    document.head.appendChild(scriptTag);
  };

  useEffect(() => {
    if (appConfig.pageSenseId) {
      addPageSenseScript();
    }
  }, []);

  return <Routes />;
};

export default App;
